import React from 'react';
import {
  TeamOutlined,
  DashboardOutlined,
  FormOutlined,
  HomeOutlined,
  LayoutOutlined,
  LineChartOutlined,
  TableOutlined,
  UserOutlined,
  BlockOutlined,
  BookOutlined,
  FileTextOutlined,
  BarChartOutlined,
  EditOutlined,
  CheckCircleOutlined,
  PlusCircleOutlined,
} from '@ant-design/icons';
import { ReactComponent as NftIcon } from '../../../../assets/icons/nft-icon.svg';
import i18n from '../../../../locale/i18n';

export interface SidebarNavigationItem {
  title: string;
  key: string;
  url?: string;
  children?: SidebarNavigationItem[];
  icon?: React.ReactNode;
  requiresAuth?: boolean; // True if this item requires authentication
}

export const sidebarNavigation: SidebarNavigationItem[] = [
  {
    title: 'sidebar:wizard',
    key: 'wizard',
    url: "/",
    icon: <BookOutlined />,
    requiresAuth: false, // Wizard доступен БЕЗ авторизации
  },
  {
    title: 'sidebar:myClasses',
    key: 'myClasses',
    url: "/my-classes",
    icon: <TeamOutlined />,
    requiresAuth: true, // Требует авторизацию
  },
  {
    title: 'sidebar:examForms',
    key: 'examForms',
    icon: <FileTextOutlined />,
    requiresAuth: true, // Требует авторизацию
    children: [
      {
        title: 'sidebar:answerSheets',
        key: 'answerSheets',
        url: "/answer-sheets",
        requiresAuth: true,
      },
      {
        title: 'sidebar:gradingScales',
        key: 'gradingScales',
        url: "/grading-scales",
        requiresAuth: true,
      }
    ],
  },
  {
    title: 'sidebar:assessments',
    key: 'assessments',
    url: "/assessments",
    icon: <EditOutlined />,
    requiresAuth: true, // Требует авторизацию
  },
  {
    title: 'sidebar:addToGrading',
    key: 'addToGrading',
    url: "/add-to-grading",
    icon: <PlusCircleOutlined />,
    requiresAuth: true, // Требует авторизацию
  },
  {
    title: 'sidebar:grading',
    key: 'grading',
    url: "/grading",
    icon: <BarChartOutlined />,
    requiresAuth: true, // Требует авторизацию
  }
];
